// extracted by mini-css-extract-plugin
module.exports = {"highlight":"TextHighlight_highlight__qk8cx","highlight-text":"TextHighlight_highlight-text__WzDJH"};